"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UploadError = exports.isFileWithPath = exports.HTTPMethod = void 0;
var HTTPMethod;
(function (HTTPMethod) {
    HTTPMethod["GET"] = "get";
    HTTPMethod["POST"] = "post";
    HTTPMethod["PUT"] = "put";
})(HTTPMethod || (exports.HTTPMethod = HTTPMethod = {}));
const isFileWithPath = (file) => {
    return !!file.path;
};
exports.isFileWithPath = isFileWithPath;
class UploadError extends Error {
}
exports.UploadError = UploadError;
//# sourceMappingURL=types.js.map